import React from 'react'
import NotificationContent from './NotificationContent'
import ActivityGroup from 'components/ActivityGroup'

export class NotificationGroup extends React.Component {
  render () {
    return (
      <ActivityGroup
        {...this.props}
        contentComponent={NotificationContent}
      />
    )
  }
}

export default NotificationGroup
